import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaWhatsapp, FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';
import { SOCIAL_LINKS, WHATSAPP_GENERAL_LINK } from '../data/products';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'Inicio', href: '#inicio' },
        { name: 'Productos', href: '#productos' },
        { name: 'Promociones', href: '#promociones', highlight: true },
        { name: 'Nosotros', href: '#nosotros' },
        { name: 'Precios', href: '#precios' },
        { name: 'Contacto', href: '#contacto' },
    ];

    const scrollToSection = (e, href) => {
        e.preventDefault();
        setIsOpen(false);
        const element = document.querySelector(href);
        if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: elementPosition, behavior: 'smooth' });
        }
    };

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur-lg shadow-lg py-2' : 'bg-transparent py-4'}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between">
                    <a href="#inicio" onClick={(e) => scrollToSection(e, '#inicio')} className="flex items-center gap-2 group">
                        <div className="relative">
                            <span className="text-3xl md:text-4xl">🧁</span>
                            <span className="absolute -top-1 -right-1 text-xs animate-heart-beat">💕</span>
                        </div>
                        <div className="flex flex-col">
                            <span className={`font-dancing text-xl md:text-2xl font-bold ${scrolled ? 'text-dulce-pink-600' : 'text-white text-shadow-lg'}`}>
                                Dulce Mora
                            </span>
                            <span className={`text-[10px] md:text-xs tracking-widest uppercase ${scrolled ? 'text-dulce-pink-400' : 'text-white/80'}`}>
                                Repostería Artesanal
                            </span>
                        </div>
                    </a>

                    { /* <div className="hidden lg:flex items-center gap-1">
                        {navLinks.map((link) => (
                            <a key={link.name} href={link.href} onClick={(e) => scrollToSection(e, link.href)}
                                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:bg-dulce-pink-100 hover:text-dulce-pink-600 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
                                {link.name}
                            </a>
                        ))}
                    </div> */}

                    <div className="hidden lg:flex items-center gap-1">
                        {navLinks.map((link) => (
                            <a key={link.name} href={link.href} onClick={(e) => scrollToSection(e, link.href)}
                                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-300 relative ${link.highlight
                                    ? scrolled
                                        ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white hover:scale-105 shadow-md'
                                        : 'bg-gradient-to-r from-red-500 to-orange-500 text-white hover:scale-105 shadow-md animate-pulse-soft'
                                    : scrolled
                                        ? 'text-gray-700 hover:bg-dulce-pink-100 hover:text-dulce-pink-600'
                                        : 'text-white hover:bg-white/20'
                                    }`}>
                                {link.highlight && (
                                    <span className="absolute -top-1 -right-1 flex h-3 w-3">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                                    </span>
                                )}
                                {link.highlight && '🔥 '}
                                {link.name}
                            </a>
                        ))}
                    </div>

                    <div className="hidden lg:flex items-center gap-3">
                        <div className="flex items-center gap-2">
                            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className={`p-1.5 rounded-full transition-colors ${scrolled ? 'text-dulce-pink-500 hover:bg-dulce-pink-50' : 'text-white hover:bg-white/20'}`}>
                                <FaInstagram size={18} />
                            </a>
                            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className={`p-1.5 rounded-full transition-colors ${scrolled ? 'text-dulce-pink-500 hover:bg-dulce-pink-50' : 'text-white hover:bg-white/20'}`}>
                                <FaFacebook size={18} />
                            </a>
                            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className={`p-1.5 rounded-full transition-colors ${scrolled ? 'text-dulce-pink-500 hover:bg-dulce-pink-50' : 'text-white hover:bg-white/20'}`}>
                                <FaTiktok size={18} />
                            </a>
                        </div>
                        <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer" className="btn-whatsapp text-sm py-2 px-4">
                            <FaWhatsapp size={18} />
                            <span>Pedir Ahora</span>
                        </a>
                    </div>

                    <button onClick={() => setIsOpen(!isOpen)} className={`lg:hidden p-2 rounded-xl transition-colors ${scrolled ? 'text-dulce-pink-600 hover:bg-dulce-pink-100' : 'text-white hover:bg-white/20'}`}>
                        {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                    </button>
                </div>
            </div>

            <div className={`lg:hidden transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <div className="bg-white/98 backdrop-blur-xl border-t border-dulce-pink-100 px-4 py-4 space-y-1 shadow-xl">
                    {navLinks.map((link) => (
                        <a
                            key={link.name}
                            href={link.href}
                            onClick={(e) => scrollToSection(e, link.href)}
                            className={`block px-4 py-3 rounded-xl font-medium transition-all duration-300 relative ${link.highlight
                                ? 'bg-gradient-to-r from-red-500 via-orange-500 to-amber-500 text-white shadow-lg hover:shadow-xl hover:scale-[1.02] animate-pulse-soft'
                                : 'text-gray-700 hover:bg-dulce-pink-50 hover:text-dulce-pink-600'
                                }`}
                        >
                            {link.highlight ? (
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2 flex-1">
                                        <div className="relative">
                                            <span className="text-xl animate-wiggle">🔥</span>
                                            <span className="absolute -top-1 -right-1 flex h-2 w-2">
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                                                <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-400"></span>
                                            </span>
                                        </div>
                                        <div className="flex flex-col">
                                            <span className="font-bold tracking-wide leading-tight">{link.name}</span>
                                            <span className="text-[10px] text-white/90 font-medium leading-tight">
                                                ¡Hasta 50% OFF! 🎁
                                            </span>
                                        </div>
                                    </div>
                                    <div className="bg-yellow-400 text-red-700 text-[10px] font-black px-2.5 py-1 rounded-full shadow-md transform rotate-3">
                                        2x1
                                    </div>
                                </div>
                            ) : (
                                link.name
                            )}
                        </a>
                    ))}

                    <div className="pt-3 border-t border-dulce-pink-100">
                        <div className="flex items-center justify-center gap-4 mb-3">
                            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-dulce-pink-500 p-2 hover:scale-110 transition-transform">
                                <FaInstagram size={22} />
                            </a>
                            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="text-dulce-pink-500 p-2 hover:scale-110 transition-transform">
                                <FaFacebook size={22} />
                            </a>
                            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="text-dulce-pink-500 p-2 hover:scale-110 transition-transform">
                                <FaTiktok size={22} />
                            </a>
                        </div>
                        <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer" className="btn-whatsapp w-full justify-center">
                            <FaWhatsapp size={20} />
                            <span>Haz tu Pedido</span>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;